/**
 * 封装请求函数
 * Created by maoyupeng on 2017/6/30.
 */

import axios from 'axios'
import { baseurl } from './url.js'
import Vue from 'vue'
import Locales from '../components/language/app.js'
import langEn from 'element-ui/lib/locale/lang/en'
import langCn from 'element-ui/lib/locale/lang/zh-CN'
import langKo from 'element-ui/lib/locale/lang/ko'
import langRu from 'element-ui/lib/locale/lang/ru-RU'
import langJP from 'element-ui/lib/locale/lang/ja'
import locale from 'element-ui/lib/locale'
import {Message} from 'element-ui'

const req = {
  common:{
    changeLang (lang) {
      let localLang = null
      // 如果lang==null则代表使用localStorage缓存的语言
      if (!lang || lang === 'undefined') {
        let oldLang = localStorage.getItem("system_lang")
        if (oldLang !== null && oldLang !== "") {
          localLang = oldLang
        }
        else {
          localLang = "zh_cn"
        }
      } else {
        localLang = lang
      }
      localStorage.setItem("system_lang",localLang)
      Vue.config.lang = localLang
      Object.keys(Locales).forEach(function (lang) {
        Vue.locale(lang, Locales[lang])
      })
      // 系统多语言
      let cLang = localStorage.getItem("system_lang")
      switch (cLang) {
        case 'en':
          locale.use(langEn)
          break
        case 'zh_cn':
          locale.use(langCn)
          break
        case 'ko':
          locale.use(langKo)
          break
        case 'ru':
          locale.use(langRu)
          break
        // case 'japan':
        //   locale.use(langJP)
      }
      /*if (cLang === 'en') {
        locale.use(langEn)
      } else if (cLang === 'zh_cn') {
        locale.use(langCn)
      }*/
    }
  },
  // =========
  // 广告模块 ||
  // =========
  advert: {
    list (data) {
      return new Promise((resolve, reject) => {
        axios.post(baseurl+'/admanage/list.do', data)
          .then( (response) => {
            resolve(response.data)
          })
      })
    }
  }, // 广告模块 end
  // =========
  // 下发指令 ||
  // =========
  order: {
    // 重启
    shutdownOrRestartTerminal (data,successText,errText,callback) {
      return new Promise((resolve, reject) => {
        axios.post(baseurl + '/terminal/shutdownOrRestartTerminal.do', data)
          .then((response) => {
            if (callback) {
              callback(response.data)
            }
            // 增加回调 eidt by wei
            // (response.data.status == 200) ? Message(response.data.message) : Message(response.data.message);
            if (response.data.status == 200) {
              Message(response.data.message)
            } else {
              Message.error(response.data.message)
            }


            resolve(response.data)
            // return new Promise((resolve, reject) => {
            //
            // })
          }).catch(() => {
          Message(errText)
        })
      });
    },
    // orderTran
    tranOrderToTerminal (data,successText,errText) {
      return new Promise((resolve, reject) => {
        
        axios.post(baseurl + '/terminal/tranOrderToTerminal.do', data)
          .then((response) => {
            // console.log(response)
            
            var msg = response.data.message
            if (response.data.status === 200) {
              Message.success(msg) 
            } else {
              Message.error(msg);
            }
            resolve(response.data)
            
          }).catch(() => {
          Message(errText)
        })
      });
    }
  }
}

export default req



// WEBPACK FOOTER //
// ./src/api/req.js